import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { claimsHomeRoute, HttpStatus } from 'config/Api.Config';
import { isDesktop, isMobile } from 'react-device-detect';
import useLossCodeCategory, { LossCodeCategoryAction } from './LossCodeCategory.Hooks';
import LossCodeCategoryDelete from './sections/LossCodeCategory.Delete';
import LossCodeCategoryEdit from './sections/LossCodeCategory.Edit';
import LossCodeCategoryFilters from './sections/LossCodeCategory.Filters';
import LossCodeCategoryList from './sections/LossCodeCategory.List';

export const lossCodeCategoryIndexRoute = claimsHomeRoute + '/lossCodeCategory/:action?/:id?';
export default function LossCodeCategoryIndex() {
  const { lang } = getLocales();
  const lossCodeCategoryHook = useLossCodeCategory();

  if (!lossCodeCategoryHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={lossCodeCategoryHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.lossCodeCategories} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <LossCodeCategoryFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_LOSSCODECATEGORY}
                    data={{ action: LossCodeCategoryAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <LossCodeCategoryFilters />}
            render={
              <>
                {views.edit && <LossCodeCategoryEdit />}
                {views.delete && <LossCodeCategoryDelete />}
                <LossCodeCategoryList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
